import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ApiConfig } from './api-config';
import { DynamicField } from '../models';

@Injectable({
  providedIn: 'root'
})
export class DynamicFieldsService {

  constructor(private http: HttpClient) { }

  getAll(subdomain: string): Observable<DynamicField[]> {
    const url = ApiConfig.getApiUrl('/dynamic_fields.json', subdomain);
    return this.http.get<DynamicField[]>(url, { withCredentials: true });
  }
}
